"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.CompEventSymbol = void 0;
exports.CompEventSymbol = Symbol('eventSymbol');
//# sourceMappingURL=compEventsRegistrar.js.map